export type SubscriberStatus =
  | "pending"
  | "active"
  | "suspended"
  | "unsubscribed";

export interface NewsletterGroup {
  id: string;
  tenant_id: string;
  name: string;
  slug: string;
  subscriber_count: number;
  created_at: string;
}

export interface NewsletterSubscriber {
  id: string;
  tenant_id: string;
  email: string;
  name?: string;
  status: SubscriberStatus;
  source: string;
  consent_at: string;
  confirmed_at?: string | null;
  unsubscribed_at?: string | null;
  created_at: string;
  updated_at: string;
  groups?: NewsletterGroup[];
}

export interface NewsletterAuditEvent {
  id: string;
  tenant_id: string;
  subscriber_id?: string | null;
  actor_type: "system" | "admin" | "subscriber";
  actor_id?: string;
  action: string;
  email_masked: string;
  email_hash: string;
  metadata?: Record<string, unknown>;
  created_at: string;
}

export interface NewsletterImportError {
  line: number;
  email?: string;
  reason: string;
}

export interface NewsletterImportResult {
  inserted: number;
  updated: number;
  skipped: number;
  errors: NewsletterImportError[];
}

export interface NewsletterListResponse {
  data: NewsletterSubscriber[];
  total: number;
  page: number;
  per_page: number;
}

export const STATUS_LABELS: Record<SubscriberStatus, string> = {
  pending: "Pendente",
  active: "Ativo",
  suspended: "Suspenso",
  unsubscribed: "Cancelado",
};

export const STATUS_CLASS: Record<SubscriberStatus, string> = {
  pending: "bg-amber-100 text-amber-700",
  active: "bg-green-100 text-green-700",
  suspended: "bg-gray-200 text-gray-700",
  unsubscribed: "bg-red-100 text-red-700",
};

export const ACTION_LABELS: Record<string, string> = {
  subscribed: "Subscrição",
  confirmed: "Confirmação",
  unsubscribed: "Cancelamento",
  suspended: "Suspensão",
  reactivated: "Reativação",
  deleted: "Remoção",
  group_created: "Grupo criado",
  group_updated: "Grupo atualizado",
  group_deleted: "Grupo removido",
  group_assigned: "Grupos alterados",
  imported: "Importação",
  exported: "Exportação",
  name_updated: "Nome atualizado",
};
